const Invoice_Format_Config = (Table_Key) => {
  return [
    {
      id: Math.random() * 10,
      name: "PrintConfig",
      fields: [
        {
          id: Math.random() * 10,
          name: "layout",
          label: "Layout",
          type: "InputDropForQuery",
          isRequired: true,
          autoFocus: true,
          masterName: "Select_Layout",
          variable: {
            SearchId: Table_Key,
            // SearchId: "Sales_Bill",
          },
        },
        {
          id: Math.random() * 10,
          name: "copies",
          label: "copies",
          dropdowndata: ["One Copy", "Two Copies", "Three Copys", "Four Copies"],
          type: "inputdrop",
          isRequired: true,
        },
        {
          id: Math.random() * 10,
          name: "type",
          label: "Report On",
          type: "text",
          isRequired: true,
          type: "inputdrop",
          dropdowndata: ["print", "pdf", "preview"],
          value: "preview",
        },
      ],
    },
  ];
};

export const printConfiguration = (Table_Key) => {
  return [
    {
      id: Math.random() * 10,
      name: "Config_Details",
      fields: [
        {
          id: Math.random() * 10,
          name: "Default_layout",
          label: "Default Layout",
          type: "InputDropForQuery",
          isRequired: true,
          autoFocus: true,
          masterName: "Select_Layout",
          variable: {
            SearchId: Table_Key,
            // SearchId: "Sales_Bill",
          },
        },
        {
          id: Math.random() * 10,
          name: "Default_copies",
          label: "Default copies",
          dropdowndata: ["One Copy", "Two Copies", "Three Copys", "Four Copies"],
          type: "inputdrop",
          isRequired: true,
        },
        {
          id: Math.random() * 10,
          name: "Default_type",
          label: "Default Report On",
          type: "text",
          isRequired: true,
          type: "inputdrop",
          dropdowndata: ["print", "pdf", "preview"],
          value: "preview",
        },
      ],
    },
  ];
};

export { Invoice_Format_Config };
